export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: '1',
    question: '韩国伦理片与普通情色片有什么区别？',
    answer: '韩国伦理片与普通情色片的本质区别在于其艺术追求和思想深度。韩国伦理片通常由知名导演执导、实力派演员出演，以人性探索、社会批判或哲学思考为核心目标。情欲元素只是叙事手段而非目的。正如李沧东导演的《燃烧》虽然包含情欲场景，但其真正探讨的是韩国社会的阶级矛盾与青年的存在困境。韩国伦理片的艺术价值在戛纳、柏林等国际电影节上得到了广泛认可。',
  },
  {
    id: '2',
    question: '如何选择适合自己的韩国伦理电影？',
    answer: '建议从三个维度进行选择：首先是导演风格，如朴赞郁的视觉美学、李沧东的现实主义、金基德的隐喻象征各有特色；其次是题材类型，从禁忌爱情到社会批判，从悬疑惊悚到古典浪漫，找到自己感兴趣的领域；最后可以参考本网站的评分和详细解析，帮助您做出选择。初学者推荐从《小姐》或《燃烧》这类国际认可度较高的作品开始。',
  },
  {
    id: '3',
    question: '韩国伦理电影为什么在国际电影节上屡获殊荣？',
    answer: '韩国伦理电影在国际上的成功源于多个方面：第一，韩国导演独特的作者风格——朴赞郁的极致美学、李沧东的人文关怀、金基德的象征主义——都具有强烈的艺术辨识度；第二，东亚文化背景下的情感表达方式给西方观众带来了新鲜的审美体验；第三，韩国电影人对社会议题的敏锐洞察和勇敢表达。全度妍凭借《密阳》获得戛纳影后、《小姐》获得戛纳金棕榈提名等都是这些优势的集中体现。',
  },
  {
    id: '4',
    question: '网站推荐的电影评分标准是什么？',
    answer: '我们的评分综合了多个维度：导演的艺术成就（30%）、剧本与叙事结构（25%）、演员表现（20%）、视觉美学（15%）和社会文化意义（10%）。评分参考了韩国青龙奖、大钟奖、戛纳电影节、柏林电影节等权威奖项的评价，同时融入了资深影评人的专业意见。9分以上为神作级别，8-9分为强推级别，7-8分为值得一看，7分以下为特定受众推荐。',
  },
  {
    id: '5',
    question: '在哪里可以观看这些韩国伦理电影？',
    answer: '本站是一个专注于韩国伦理电影鉴赏与研究的文化交流平台，提供专业的影片解析和推荐。我们不提供任何影片的下载或在线播放服务。您可以通过Netflix、Watcha、Wavve等正版流媒体平台观看部分影片，也可以关注韩国电影资料馆（Korean Film Archive）的放映活动。建议通过正规渠道支持韩国电影人的创作。',
  },
  {
    id: '6',
    question: '韩国伦理片的历史发展脉络是怎样的？',
    answer: '韩国伦理电影的发展经历了几个重要阶段：1990年代末，随着韩国电影审查制度的放宽，《美人》等作品开始探索情欲题材；2000年代初，《丑闻》和《霜花店》等古装伦理片兴起，将情欲与历史叙事结合；2010年代至今是黄金期，《小姐》、《燃烧》、《恩娇》等作品将韩国伦理电影推向了艺术高峰，在国际上获得了前所未有的认可。这一发展历程反映了韩国社会对自由表达的追求和电影工业的成熟。',
  },
];